import { render } from "./PublishedRoundBar.vue?vue&type=template&id=b5585ca0&scoped=true"
import script from "./PublishedRoundBar.vue?vue&type=script&lang=js"
export * from "./PublishedRoundBar.vue?vue&type=script&lang=js"

import "./PublishedRoundBar.vue?vue&type=style&index=0&id=b5585ca0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5585ca0"]])

export default __exports__